import {GoogleCclStatusEnum} from '../../../../../../../../service/google/google-type';

export const ACTIONABLE_STATUSES = [GoogleCclStatusEnum.ActionRequired, GoogleCclStatusEnum.Skipped];
